<template>
    <v-container align-start>
        <v-form
            class="form-email"
            v-model="valid"
            ref="form"
            @submit.native.prevent="next"
        >
            <v-layout>
                <p v-if="isVerification">
                    {{ lang.email_binding_text }}{{ bindingValue }}
                </p>
                <v-flex xs12 v-else>
                    <v-text-field
                        v-model="email"
                        solo
                        :label="lang.security_email_label"
                        :disabled="pageLoading"
                        :readonly="sending"
                        :rules="rules"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <verification-code
                v-model="code"
                :params="{ email }"
                type="email"
                :stop="isCountDownStop"
                :error="isErrCode"
                :disabled="(!isEmailValid || isErrValue) && !isVerification"
                @send="v => (sending = v)"
            ></verification-code>
            <v-btn
                block
                :disabled="!valid"
                class="btn-h48"
                color="primary"
                @click="next"
            >
                {{ buttonText }}
            </v-btn>

            <v-btn
                class="ma-0 right"
                color="primary"
                flat
                small
                @click="choseVType"
                v-if="isVerification && isOtherVerificationTypeShow"
            >
                {{ lang.use_other_verification_type_text }}
            </v-btn>
        </v-form>
        <q-dialog
            :visible.sync="dialogVisible"
            active="email"
            v-if="isOtherVerificationTypeShow"
        ></q-dialog>
        <v-dialog v-model="alertVisible">
            <v-card :color="alertType" dark>
                <v-card-text>
                    <v-layout align-center>
                        <span>{{ lang["submit_" + alertType + "_tips"] }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            fab
                            small
                            light
                            @click="alertVisible = false"
                        >
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import VerificationCode from "@/components/VerificationCode";
import QDialog from "@/components/QDialog";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "Email",
    components: {
        VerificationCode,
        QDialog
    },
    data() {
        return {
            alertVisible: false,
            alertType: "",
            dialogVisible: false,
            email: "",
            code: "",
            sending: false,
            valid: false,
            isErrValue: false,
            isErrCode: false,
            isCountDownStop: false
        };
    },
    computed: {
        ...mapState([
            "authVerifiedType",
            "pageLoading",
            "pageParent",
            "params"
        ]),
        ...mapGetters(["lang", "securityObj", "settedSecurities"]),
        isOtherVerificationTypeShow() {
            return this.settedSecurities.length > 1;
        },
        bindingValue() {
            return this.securityObj.email.value;
        },
        isVerification() {
            return (
                !this.authVerifiedType ||
                this.authVerifiedType === "verification"
            );
        },
        buttonText() {
            return !this.isVerification
                ? this.lang.submit_text
                : this.lang.next_step_text;
        },
        isEmailValid() {
            let regEmail = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regEmail.test(this.email);
        },
        rules() {
            let tmp = [];
            tmp.push(v => !v && this.lang.empty_email_tips);
            tmp.push(() => this.isEmailValid || this.lang.iscorrect_email_tips);
            tmp.push(() => this.isErrValue && this.lang.iscorrect_email_tips);
            return tmp;
        },
        action() {
            let tmp;
            if (this.isVerification) {
                tmp =
                    this.pageParent === "password"
                        ? this.verifyCodeFFTR
                        : this.verifyCodeFVS;
                return tmp;
            }
            switch (this.authVerifiedType) {
                case "password":
                    tmp = this.setSecurityFPTS;
                    break;
                case "email":
                    tmp = this.setSecurityFSTS;
                    break;
                case "mobile":
                    tmp = this.setSecurityFSTS;
                    break;
                case "question":
                    tmp = this.setSecurityFSTS;
                    break;
            }
            return tmp;
        }
    },
    watch: {
        email() {
            this.isErrValue = false;
        },
        code(val) {
            if (val) {
                this.isErrCode = false;
            }
        },
        alertVisible(val) {
            if (!val) {
                this.changeAuthVerified("");
                this.$router.push({
                    name: "security",
                    query: Object.assign({}, this.params, {
                        t: Date.now()
                    })
                });
            }
        }
    },
    methods: {
        ...mapActions([
            "verifyCodeFVS",
            "verifyCodeFFTR",
            "setSecurityFPTS",
            "setSecurityFSTS"
        ]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            changeAuthVerified: "CHANGE_AUTH_VERIFIED"
        }),
        choseVType() {
            if (this.pageLoading) {
                return;
            }
            this.dialogVisible = true;
        },
        next() {
            let params = {
                type: "email",
                email: this.email,
                email_code: this.code
            };
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            this.action(params)
                .then(() => {
                    this.isCountDownStop = true;
                    if (this.isVerification) {
                        this.changeAuthVerified("email");
                        this.$router.push({
                            name: this.$route.query.redirect,
                            query: Object.assign({}, this.params, {
                                t: Date.now()
                            })
                        });
                    } else {
                        this.alertVisible = true;
                        this.alertType = "success";
                    }
                })
                .catch(err => {
                    if (err.code === 1001) {
                        this.isErrCode = true;
                    } else if (err.code === 1002) {
                        this.isErrValue = true;
                    } else if (err.code === 1003) {
                        this.alertVisible = true;
                        this.alertType = "error";
                    }
                    setTimeout(() => {
                        this.changePageLoading(false);
                        this.$refs.form.validate();
                    }, 300);
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.form.reset();
        next();
    }
};
</script>
